import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  LeaderboardParticipantPort,
  type ActivateLeaderboardParticipantParams,
} from '../../../domain/leaderboard/ports/leaderboard-participant.port';
import type { ActivateParticipantOutcome } from '../../../domain/leaderboard/models/activate-participant.model';
import type {
  ActivateParticipantApiData,
  LeaderboardEventsDataResponse,
} from '../dtos/leaderboard-public-api.dto';
import { leaderboardBoardBaseUrl } from '../utils/leaderboard-events-http.util';

@Injectable({ providedIn: 'root' })
export class LeaderboardParticipantHttpAdapter extends LeaderboardParticipantPort {
  constructor(private readonly http: HttpClient) {
    super();
  }

  activate(params: ActivateLeaderboardParticipantParams): Observable<ActivateParticipantOutcome> {
    const uid = params.uid?.trim();
    const base = leaderboardBoardBaseUrl(params.commerceId, params.leaderboardId);
    if (!base || !uid) {
      return of({ status: 'skipped' });
    }

    return this.http
      .post<LeaderboardEventsDataResponse<ActivateParticipantApiData>>(
        `${base}/participant/activate`,
        {
          uid,
          ...(params.termsAccepted === true ? { terms_accepted: true } : {}),
        },
      )
      .pipe(
        map((): ActivateParticipantOutcome => ({ status: 'activated' })),
        catchError((err: unknown): Observable<ActivateParticipantOutcome> => {
          if (err instanceof HttpErrorResponse && err.status === 409) {
            return of({ status: 'already_active' });
          }
          const httpStatus = err instanceof HttpErrorResponse ? err.status : undefined;
          return of({ status: 'failed', httpStatus });
        }),
      );
  }
}
